import { createSlice } from '@reduxjs/toolkit';

export const initialParams = {
  EDI_ID: '',
  ERROR_ONLY: true,
  S_DT: null,
  E_DT: null,
  SDT_TIME_FROM: null,
  SDT_TIME_TO: null,
  TIME_LOCALE: '2',
  // limit: 10,
};

const initialState = {
  ...initialParams,
  total: 0,
  listEdiLog: [],
  ediLogDetail: {},
  loadingGetListEdi: false,
  ediIdList: [],
  ediLogDetailColumn: [],
  ediLogDetailData: [],
  message: '',
  ediListMessage: '',
  statusErr: false,
};

export const ediSlice = createSlice({
  name: 'edi',
  initialState,
  reducers: {
    handleGetListEdiLogRequest: (state, action) => {
      state.loadingGetListEdi = true;
    },
    handleGetListEdiLogResponse: (state, action) => {
      const { payload } = action;
      state.loadingGetListEdi = false;
      state.listEdiLog = payload?.data?.records;
      state.total = payload?.data?.total;
      state.ediListMessage = payload?.ediListMessage;
    },
    handleGetEdiLogDetailRequest: (state, action) => {},
    handleGetEdiLogDetailResponse: (state, action) => {
      const { payload } = action;
      state.ediLogDetail = payload?.detailTitleInfo;
      state.ediLogDetailColumn = payload?.detailHead;
      state.ediLogDetailData = payload?.detail;
      state.message = payload?.message;
      state.statusErr = payload?.statusErr;
    },
    handleGetListEdiIdRequest: (state) => {},
    handleGetListEdiIdResponse: (state, action) => {
      const { payload } = action;
      state.ediIdList = payload;
    },
    cleanData: (state) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  handleGetListEdiLogRequest,
  handleGetListEdiLogResponse,
  handleGetEdiLogDetailRequest,
  handleGetEdiLogDetailResponse,
  handleGetListEdiIdRequest,
  handleGetListEdiIdResponse,
  cleanData,
} = ediSlice.actions;

export default ediSlice.reducer;
